"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
export default function SpecialsAndDrinksCta() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative bg-background py-16 md:py-20 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div ref={leftRef} className="relative overflow-hidden rounded-lg shadow-medium transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateX(0)" : "translateX(-40px)"
        }}>
            <div className="aspect-[4/3] overflow-hidden group">
              <img src="https://texasmargaritasmexicanrestaurant.com/wp-content/uploads/2026/01/Margaritas-texas-marg.webp" alt="Vibrant margaritas on the rocks" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-[1.01]" />
            </div>
          </div>

          {}
          <div ref={rightRef} className="flex flex-col justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateX(0)" : "translateX(40px)"
        }}>
            <div className="bg-primary-light rounded-lg p-8 md:p-10 shadow-soft border border-primary/10">
              <div className="flex items-center gap-3 mb-4">
                <Sparkles className="size-6 text-primary" />
                <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground">
                  Signature Margaritas & Daily Specials
                </h2>
              </div>
              <p className="text-foreground-muted-light text-base md:text-lg leading-relaxed mb-6">
                Indulge in our handcrafted margaritas made with premium tequila
                and fresh-squeezed lime. From classic to bold flavors like mango
                habanero and jalapeño cucumber, every sip delivers authentic
                Mexican zest. Check out our rotating daily specials for even more
                delicious reasons to celebrate!
              </p>
              <Link to="/MenuPage">
                <Button size="lg" className="inline-flex items-center gap-2 text-base transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] active:scale-100">
                  View Drink Menu
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}